import AppRouter from "./routes/AppRouter"
import NetworkStatus from "./components/NetworkStatus"
import { AppInitializer } from "./components/AppInitializer"
import { UserProvider } from "./context/UserContext"
import { BranchProvider } from "./context/BranchContext"

export default function App() {
  return (
    <UserProvider>
      <BranchProvider>
        <>
          <AppInitializer />
          <NetworkStatus />
          <AppRouter />
        </>
      </BranchProvider>
    </UserProvider>
  )
}